import ContentManager from "../ContentManager";

const ProductsAdmin = () => (
  <ContentManager type="product" title="Products"
    description="Manage the product sections shown on the public Products page. Save & Publish makes changes live immediately — no website republish needed." />
);

export default ProductsAdmin;
